var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c(
        "a-spin",
        {
          staticClass: "draft-con",
          attrs: { size: "large", spinning: _vm.loading },
        },
        [
          !(_vm.tableData && _vm.tableData.length)
            ? _c(
                "div",
                { staticClass: "no-data-box" },
                [
                  _c("NoData", {
                    attrs: { lang: _vm.lang, text: _vm.$t("noDraft") },
                  }),
                ],
                1
              )
            : [
                _c("a-table", {
                  staticClass: "custom-scrollbar capinTable",
                  class: { arTable: _vm.lang == "AR" ? true : false },
                  attrs: {
                    size: "middle",
                    columns: _vm.columns,
                    rowKey: (record, index) => index,
                    "data-source": _vm.tableData,
                    pagination: false,
                    loading: _vm.tableLoading,
                    locale: { emptyText: _vm.$t("noDraft") },
                    "row-class-name": (_record, index) =>
                      index % 2 !== 1 ? "table-bg" : null,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "action",
                      fn: function (text, record) {
                        return [
                          _c(
                            "a-dropdown",
                            {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "overlay",
                                    fn: function () {
                                      return [
                                        _c(
                                          "a-menu",
                                          [
                                            _c(
                                              "a-menu-item",
                                              {
                                                key: "0",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.goEdit(record)
                                                  },
                                                },
                                              },
                                              [
                                                _c("a-icon", {
                                                  attrs: { type: "form" },
                                                }),
                                                _c(
                                                  "span",
                                                  { class: [_vm.lang] },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("campaignEdit")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "a-menu-item",
                                              {
                                                key: "3",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteHandler(
                                                      record
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("a-icon", {
                                                  attrs: { type: "delete" },
                                                }),
                                                _c(
                                                  "span",
                                                  { class: [_vm.lang] },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("Delete"))
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c(
                                "a-button",
                                {
                                  staticStyle: { padding: "0 8px" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.clickHandler.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("span", { class: [_vm.lang] }, [
                                    _vm._v(_vm._s(_vm.$t("Action"))),
                                  ]),
                                  _c("a-icon", { attrs: { type: "down" } }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm.showPagination
                  ? _c(
                      "div",
                      [
                        _c("app-footer", {
                          attrs: {
                            current: _vm.page,
                            pageSize: _vm.pageSize,
                            total: _vm.total,
                          },
                          on: {
                            onPageChange: _vm.onPageChange,
                            onPageSizeChange: _vm.onPageSizeChange,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }